import React, {useEffect} from 'react';
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import {useNavigate} from "react-router-dom";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";

function Bemvindo() {
    const navigate = useNavigate();
    const {hasRole, user} = useKeycloak();

    useEffect(() => {
        if (user && user.id && hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            navigate("/restaurante");
        }
    }, [user]);

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.CLIENTE}>
                <div>
                    <h3 style={{display: "flex", alignItems: "center", gap: "8px"}}>
                        <i className="pi pi-spin pi-spinner" style={{fontSize: '2rem'}}></i>
                        Aguarde...
                    </h3>
                </div>
            </RoleBasedAccess>

            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}>
                <div className="card">
                    <h2>Seja bem-vindo</h2>
                    <h6>Versão: 1.4.0</h6>
                </div>
            </RoleBasedAccess>
        </>
    );
}

export default Bemvindo;